import { getAction, XhrStatusResponse, operationSuccess } from '../xhr';

interface CartItemWS {
  // art_caract_1: string;
  // art_caract_2: string;
  // art_caract_3: string;
  // art_caract_4: string;
  // art_caract_5: string;
  // art_color: string;
  // art_copete: string;
  // art_descripcion: string;
  // art_marid: string;
  // art_tamano: string;
  // color_render: string;
  // destacado: boolean;
  // destacado_leyenda: string;
  // disponible: boolean;
  // id: string;
  // imagen_1_src: string;
  // mar_nombre: string;
  // mar_orden: string;
  // marcaNombre: string;
  // mas_vendido: boolean;
  // novedad: boolean;
  // oferta: boolean;
  // precioLista_formatted: string;
  // precioOferta_formatted: string;
  // precio_x_cantidad: string;
  // snippet_key: string;
  art_imagen1: string;
  ci_artid: string;
  ci_cant: string;
  ci_carid: string;
  ci_combo_id: null;
  ci_id: string;
  ci_item_detalle: string;
  ci_iva_importe: number;
  ci_ivaa_id: string;
  ci_nro: string;
  ci_ppaid: null;
  ci_pplus: string;
  ci_precio: number;
  ci_promocion_beneficio_id: null;
  ci_ptos_pplus: number;
}

interface CartDataWS {
  products: CartItemWS[];
  subtotal: string;
  subtotalSinFormato: number;
}

export interface CartItem extends Omit<CartItemWS, 'ci_cant'> {
  ci_cant: number;
}
export interface CartData extends Omit<CartDataWS, 'products'> {
  products: CartItem[];
}

export const entityName = 'Carrito';

export const getCart = async (): Promise<CartData | null> => {
  const res = await getAction<XhrStatusResponse<CartDataWS>>(entityName);
  if (!operationSuccess(res)) {
    // TODO: Procesar error
  }
  if (res && res.data) {
    return {
      ...res.data,
      products: res.data.products.map((item): CartItem => ({ ...item, ci_cant: Number(item.ci_cant) })),
    };
  }

  return null;
};
